import React from 'react';
import { useStyletron } from 'baseui';
import { Button, KIND as BUTTON_KIND, SIZE as BUTTON_SIZE } from 'baseui/button';
import { LabelSmall } from 'baseui/typography';
export type PendingAnnotationDetailsProps = {
  id: string;
  list: {
    label: string;
    value: string;
    endEnhancer?: React.ReactNode;
  }[];
  onAction: (id: string) => void;
};
export const PendingAnnotationDetails = ({
  id,
  list,
  onAction
}: PendingAnnotationDetailsProps) => {
  const [css, theme] = useStyletron();
  return <div className={css({
    padding: theme.sizing.scale500,
    borderRadius: theme.borders.radius300,
    border: `2px solid ${theme.colors.borderOpaque}`,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.sizing.scale500
  })}>
      {list.map(item => <section key={item.label} className={css({
      display: 'flex',
      alignItems: 'center',
      gap: theme.sizing.scale300
    })}>
          <LabelSmall margin={0} color={theme.colors.contentTertiary}>
            {item.label}
          </LabelSmall>
          <LabelSmall margin={0} color={theme.colors.contentTertiary}>
            :
          </LabelSmall>
          <LabelSmall margin={0} color={theme.colors.contentPrimary} className={css({
        textTransform: 'capitalize',
        wordBreak: 'break-all'
      })}>
            {item.value}
          </LabelSmall>
          <div className={css({
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.sizing.scale300,
        gap: theme.sizing.scale300
      })}>
            {item.endEnhancer}
          </div>
        </section>)}
      <Button kind={BUTTON_KIND.secondary} size={BUTTON_SIZE.compact} onClick={() => onAction(id)}>
        Complete questionnaire
      </Button>
    </div>;
};